import { handleActions, combineActions } from 'redux-actions'
import { Map } from 'immutable'
import * as actions from './actions'

export const bannedIPs = handleActions(
  {
    [combineActions(actions.fetchBannedIPsSuccess, actions.banIPSuccess, actions.unbanIPSuccess)]: (
      state,
      action
    ) => {
      return state.set('ips', action.payload)
    },
  },
  Map()
)

export const bannedIPStatus = handleActions(
  {
    [combineActions(
      actions.fetchBannedIPsFailed,
      actions.fetchBannedIPsPending,
      actions.fetchBannedIPsSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'fetch'], action.type)
    },

    [combineActions(actions.banIPFailed, actions.banIPPending, actions.banIPSuccess)]: (state, action) => {
      return state.setIn(['status', 'ban'], action.type)
    },

    [combineActions(actions.unbanIPFailed, actions.unbanIPPending, actions.unbanIPSuccess)]: (
      state,
      action
    ) => {
      return state.setIn(['status', 'unban'], action.type)
    },
  },
  Map()
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/ban/reducer.js